import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Login.css";
import Logo from "../../nourtunelogohome.png";

const Login = ({ Ip }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get(`${Ip}/Dashboard/session_check.php`, {
          withCredentials: true,
        });
        if (response.data.loggedIn) {
          window.location.href = "/dashboard";
        }
      } catch (err) {
        console.error(err);
      }
    };
    checkSession();
  }, [Ip]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${Ip}/Dashboard/login.php`,
        formData,
        { withCredentials: true }, // important for cookies
      );

      if (response.data.status === "success") {
        console.log("Session ID:", response.data.debug_session_id);
        console.log("Session Data:", response.data.debug_session_data);

        // redirect after successful login
        window.location.href = "/dashboard";
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      setError("Server error. Please try again.");
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src={Logo} alt="NourTune Logo" className="login-logo" />
        <h2>Dashboard Login</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="username"
            name="email"
            placeholder="Username"
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
            required
          />

          {error && <p className="error">{error}</p>}

          <button type="submit" disabled={loading}>
            {loading ? "Signing In..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
